import { Link } from 'react-router-dom';
import '../../general_styles.css';
import './navigation.css';

function NavigationMenu() {
    return (
        <nav className='navigation'>
            <div className='step__container'>
                <div className='step'>
                    <p className='step__number'>1</p>
                    <div className='step__text'>
                        <h2>Step 1</h2>
                        <p>Your Info</p>
                    </div>
                </div>
                <div className='step'>
                    <p className='step__number'>2</p>
                    <div className='step__text'>
                        <h2>Step 2</h2>
                        <p>Select Plan</p>
                    </div>
                </div>
                <div className='step'>
                    <p className='step__number'>3</p>
                    <div className='step__text'>
                        <h2>Step 3</h2>
                        <p>Add-ons</p>
                    </div>
                </div>
                <div className='step'>
                    <p className='step__number'>4</p>
                    <div className='step__text'>
                        <h2>Step 4</h2>
                        <p>Summary</p>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default NavigationMenu;